<template>
  <div class="multiple-inputs">
    <div class="input-container">
      <div>
        <label>{{ title }}</label>
        <br />
        <label class="mr-2">Tekst checkboxa: </label>
        <input type="text" style="width: 400px" v-model="newRegulationText" />
        <br />
        <label class="mr-2" style="display: flex; align-items: center"
          >Wymagany do zaakceptowania:
        </label>
        <input
          type="radio"
          v-model="newRegulationIsCheckboxRequired"
          name="isCheckboxRequired"
          :value="true"
        />
        Tak
        <input
          type="radio"
          v-model="newRegulationIsCheckboxRequired"
          name="isCheckboxRequired"
          :value="false"
        />
        Nie
        <br />
        <div
          class="btn btn-outline-dark mt-2 mb-2"
          @click="addServiceRegulation"
        >
          Zapisz checkbox
        </div>
        <br />
        <label>Dodane checkboxy:</label>
        <div>
          <p v-for="regulation in newServiceRegulations" :key="regulation.id">
            {{ regulation.text }}
            {{ regulation.is_required ? "*" : "" }}
            <span
              class="btn btn-outline-dark mt-2 mb-2"
              @click="removeServiceRegulation(regulation)"
            >
              Usuń
            </span>
          </p>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServicesCheckboxes",
  props: ["title", "addedCheckboxes"],
  data() {
    return {
      newRegulationText: "",
      newRegulationIsCheckboxRequired: false,
      newServiceRegulations: [],
      newRegulationIndex: 1,
    };
  },
  mounted() {
    this.addedCheckboxes.forEach((checkbox) => {
      this.newServiceRegulations.push({
        text: checkbox.text,
        is_required: checkbox.is_required,
        id: this.newRegulationIndex,
      });
      this.newRegulationIndex++;
    });
  },
  methods: {
    addServiceRegulation() {
      if (this.newRegulationText && this.newRegulationText.length > 2048) {
        this.$notify({
          group: "error",
          text: "Niepoprawny tekst checkboxa, maksymalna długość to 2048 znaków",
        });
        return;
      }
      if (this.newRegulationText === "") {
        this.$notify({
          group: "error",
          text: "Wymagane podanie wartości dla checkboxa",
        });
        return;
      }
      let alreadyExist = false;
      this.newServiceRegulations.forEach((serviceRegulation) => {
        if (serviceRegulation.text === this.newRegulationText) {
          alreadyExist = true;
        }
      });
      if (alreadyExist) {
        this.$notify({
          group: "error",
          text: "Checkbox z taką wartością został już dodany",
        });
        return;
      }

      this.newServiceRegulations.push({
        text: this.newRegulationText,
        is_required: this.newRegulationIsCheckboxRequired,
        id: this.newRegulationIndex,
      });
      this.newRegulationIndex++;
    },

    removeServiceRegulation(regulation) {
      this.newServiceRegulations = this.newServiceRegulations.filter(
        (serviceRegulation) => {
          return serviceRegulation.text !== regulation.text;
        }
      );
    },
  },
  watch: {
    newServiceRegulations: {
      handler: function (newServiceRegulations) {
        this.$emit("checkboxesUpdated", newServiceRegulations);
      },
      deep: true,
    },
    addedCheckboxes: {
      handler: function (addedCheckboxes) {
        if (this.newServiceRegulations.length === 0) {
          this.newRegulationIndex = 1;
          addedCheckboxes.forEach((checkbox) => {
            this.newServiceRegulations.push({
              text: checkbox.text,
              is_required: checkbox.is_required,
              id: this.newRegulationIndex,
            });
            this.newRegulationIndex++;
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.multiple-inputs {
  display: flex;
  align-items: center;
}
.input-container {
  font-size: 15px;
}
.input-container label {
  font-size: 15px;
}
</style>